import {
  SET_CULTURE_REDUCER_STATE,
  CLEAR_CULTURE_REDUCER_STATE,
  SET_CULTURE_DYNAMIC_SINGLE_STATE,
  SET_CULTURE_DIMENTION_STATE,
  SET_WEIGHTAGE_CULTURE_PROFILE,
  SET_CULTURE_DYANMIC_DIMENTION_STATE,
  SET_CULTURE_SETUP_INFO_STATE
} from '../actionType';

const initialState = {
  cultureProfileInformation: {
    informationBasic: {
      cultureProfileName: '',
      cultureProfileNameVerification: false,
      cultureProfileDescription: '',
      cultureProfilePicture: '',
      cultureProfilePictureVerification: false
    },
    informationAllocation: {
      cultureProfileGroup: {
        cultureProfileGroupPrimary: [],
        cultureProfileGroupSecondary: []
      },
      cultureProfileNode: {
        cultureProfileNodePrimary: [],
        cultureProfileNodeSecondary: []
      },
      cultureProfileType: {
        cultureProfileTypePrimary: [],
        cultureProfileTypeSecondary: []
      }
    },
    informationSetup: {
      cultureProfileShareFee: 0.0,
      cultureProfileSellFee: 0.0,
      cultureProfileMoveFee: 0.0,
    },
    informationFramework: {
      cultureProfileCultureDimensionSelectList: [],
      cultureProfileCultureDimensionCore: [],
      cultureProfileCultureDimensionCoreObj: []
    }
    
  }
};

const CultureProfileCreateReducer = (istate = JSON.parse(JSON.stringify(initialState)), action) => {
  // console.log(action.type);
  switch (action.type) {
    case SET_CULTURE_REDUCER_STATE:
      return {
        ...istate,
        cultureProfileInformation: {
          ...istate.cultureProfileInformation,
          informationBasic: action.payload
        }
      };
    case SET_CULTURE_DIMENTION_STATE:
      return {
        ...istate,
        cultureProfileInformation: {
          ...istate.cultureProfileInformation,
          informationFramework: action.payload
        }
      };
    case SET_CULTURE_SETUP_INFO_STATE:
      return {
        ...istate,
        cultureProfileInformation: {
          ...istate.cultureProfileInformation,
          informationSetup: action.payload
        }
      };
    case SET_CULTURE_DYANMIC_DIMENTION_STATE:
      return {
        ...istate,
        cultureProfileInformation: {
          ...istate.cultureProfileInformation,
          informationFramework: {
            ...istate.cultureProfileInformation.informationFramework,
            [action.payload.stateName]: action.payload.value
          }
        }
      };
    case SET_CULTURE_DYNAMIC_SINGLE_STATE:
      return {
        ...istate,
        cultureProfileInformation: {
          ...istate.cultureProfileInformation,
          [action.payload.objectName]: {
            ...istate.cultureProfileInformation[action.payload.objectName],
            [action.payload.stateName]: {
              ...istate.cultureProfileInformation[action.payload.objectName][
                action.payload.stateName
              ],
              [action.payload.actualStateName]: action.payload.value
            }
          }
        }
      };
    case SET_WEIGHTAGE_CULTURE_PROFILE:
      let tempArr =
        istate?.cultureProfileInformation?.informationFramework
          ?.cultureProfileCultureDimensionCoreObj || [];
      let coreArr =
        istate?.cultureProfileInformation?.informationFramework
          ?.cultureProfileCultureDimensionSelectList || [];
      tempArr.forEach((element) => {
        if (
          element.iGaugeOccupationFrameworkOneTag === action.payload.iGaugeOccupationFrameworkOneTag
        ) {
          element.iGaugeOccupationFrameworkOneWeightage =
            action.payload.iGaugeOccupationFrameworkOneWeightage;
        }
      });
      coreArr.forEach((element) => {
        if (
          element.iGaugeOccupationFrameworkOneTag === action.payload.iGaugeOccupationFrameworkOneTag
        ) {
          element.iGaugeOccupationFrameworkOneWeightage =
            action.payload.iGaugeOccupationFrameworkOneWeightage;
        }
      });
      return {
        ...istate,
        cultureProfileInformation: {
          ...istate.cultureProfileInformation,
          informationFramework: {
            ...istate.cultureProfileInformation.informationFramework,
            cultureProfileCultureDimensionCoreObj: tempArr,
            cultureProfileCultureDimensionSelectList: coreArr
          }
        }
      };
    case CLEAR_CULTURE_REDUCER_STATE:
      return JSON.parse(JSON.stringify(initialState));
    default:
      return istate;
  }
};

export default CultureProfileCreateReducer;
